import { render } from "./GenericPage.vue?vue&type=template&id=fa5ea50a&scoped=true"
import script from "./GenericPage.vue?vue&type=script&lang=ts"
export * from "./GenericPage.vue?vue&type=script&lang=ts"

import "./GenericPage.vue?vue&type=style&index=0&id=fa5ea50a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-fa5ea50a"

export default script